import React from "react";
import {
  Box,
  Stack,
  Flex,
  Text,
  Button,
  useDisclosure,
  Spacer,
  Link,
  Image,
  chakra,
  useColorModeValue,
  Input,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SkeletonCircle,
  SkeletonText,
  Skeleton,
  Avatar,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  EmailIcon,
  LockIcon,
  SearchIcon,
  Icon,
  ChevronDownIcon,
} from "@chakra-ui/icons";
import { Link as ReachLink } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaUserAlt,
  FaSignOutAlt,
  FaPencilAlt,
  FaKey,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../redux/Store";
import { useHistory } from "react-router";
import { logoutUser } from "../../redux/actions/user/UserActions";
import { useState } from "react";

function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleToggle = () => (isOpen ? onClose() : onOpen());
  const userState = useSelector((state: RootStore) => state.user);
  const userUIState = useSelector((state: RootStore) => state.ui);
  const [searchKeyword, setsearchKeyword] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();
  const HandleLogout = () => {
    dispatch(logoutUser(history));
  };
  const handleSearch = (event: any) => {
    event.preventDefault();
    if (searchKeyword) {
      history.push("/search-results/" + searchKeyword);
    }
  };
  return (
    <>
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        padding={2}
        paddingLeft={10}
        paddingRight={10}
        background="#1E1F29"
        color="#F8EEEE"
      >
        <Box p="1">
          <a href="mailto:contact@goodregime.com">
            <EmailIcon color="#D10024" /> contact@goodregime.com
          </a>
        </Box>
        <Box p="1">
          <Text>
            <Icon as={FaMapMarkerAlt} color="#D10024" />
            Kathmandu, Nepal
          </Text>
        </Box>
        <Spacer />
        {!userState.authenticated ? (
          <Box
            // mt={{ base: 4, md: 0 }}
            alignItems="center"
          >
            <Link
              className="btn"
              background="#1E1F29"
              height="fit-content"
              borderRadius="5px"
              padding={1.5}
              paddingInline={2}
              _hover={{ bg: "dodgerblue", borderColor: "teal.700" }}
              colorScheme="blue"
              as={ReachLink}
              to="/user-login"
              marginRight="15px"
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
            >
              <LockIcon marginRight="5px" />
              Login
            </Link>
            <Link
              background="#D10024"
              height="fit-content"
              borderRadius="5px"
              padding={1.5}
              paddingInline={2}
              className="btn"
              _hover={{ bg: "dodgerblue", color: "white" }}
              colorScheme="blue"
              as={ReachLink}
              to="/user-register"
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
            >
              <Icon as={FaUserAlt} marginRight="5px" />
              Register
            </Link>
          </Box>
        ) : (
          <Menu autoSelect={false}>
            <MenuButton>
              {!userUIState.userLoading ? (
                <>
                  <HStack>
                    <Avatar
                      boxSize="2.5rem"
                      borderRadius="full"
                      src={userState.loggedInUserData?.user?.profilePicture}
                      name={
                        userState.loggedInUserData?.user?.firstName +
                        " " +
                        userState.loggedInUserData?.user?.lastName
                      }
                    />
                    <span>
                      {userState.loggedInUserData?.user?.firstName}{" "}
                      {userState.loggedInUserData?.user?.lastName}
                      <ChevronDownIcon />
                    </span>
                  </HStack>
                </>
              ) : (
                <HStack>
                  <SkeletonCircle boxSize="2.5rem" />
                  <SkeletonText width={100} noOfLines={1} />
                </HStack>
              )}
            </MenuButton>
            <MenuList color="white" bgColor="#1e1f29">
              <MenuItem _hover={{ color: "black" }}>
                <Link
                  height="auto"
                  width="100%"
                  _focus={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                  _hover={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                  as={ReachLink}
                  to="/user-my-profile"
                >
                  <HStack>
                    <Icon as={FaPencilAlt} boxSize="1rem" mr="12px" />
                    <Text>Update details</Text>
                  </HStack>
                </Link>
              </MenuItem>
              <MenuItem _hover={{ color: "black" }}>
                <Link
                  height="auto"
                  width="100%"
                  _focus={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                  _hover={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                  as={ReachLink}
                  to="/user-change-password"
                >
                  <HStack>
                    <Icon as={FaKey} boxSize="1rem" mr="12px" />
                    <Text>Change Password</Text>
                  </HStack>
                </Link>
              </MenuItem>
              <MenuItem onClick={HandleLogout} _hover={{ color: "black" }}>
                <Link
                  height="auto"
                  width="100%"
                  _focus={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                  _hover={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                >
                  <HStack>
                    <Icon as={FaSignOutAlt} boxSize="1rem" mr="12px" />
                    <Text>Logout</Text>
                  </HStack>
                </Link>
              </MenuItem>
            </MenuList>
          </Menu>
        )}
      </Flex>
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        paddingLeft={5}
        paddingRight={5}
      >
        <Box p="1">
          <Link
            as={ReachLink}
            to="/"
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
          >
            <Image
              width="40"
              height="20"
              objectFit="contain"
              src="/Logo.svg"
              alt="Good Regime"
            />
          </Link>
        </Box>
        <Box display={{ base: "block", md: "none" }} onClick={handleToggle}>
          <HamburgerIcon w={7} h={7} />
        </Box>
        <Box p="1">
          <HStack>
            <chakra.form onSubmit={handleSearch}>
              <HStack direction={{ base: "column", md: "row" }}>
                <Input
                  id="SearchBar"
                  value={searchKeyword}
                  onChange={(event) => {
                    setsearchKeyword(event.target.value);
                  }}
                  bg={useColorModeValue("white", "inherit")}
                  placeholder="Search by Countries"
                  required
                  focusBorderColor={useColorModeValue("blue.500", "blue.300")}
                  _placeholder={{
                    opacity: 1,
                    color: useColorModeValue("gray.500", "whiteAlpha.700"),
                  }}
                />
                <IconButton
                  id="SearchButton"
                  aria-label="Search database"
                  icon={<SearchIcon />}
                  colorScheme="blue"
                  onClick={handleSearch}
                  borderRadius="5px"
                  _focus={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                />
              </HStack>
            </chakra.form>
            {/* </Box>
          <Box p="1"> */}
            <Button
              background="#D10024"
              width="28"
              _hover={{ bg: "orange", borderColor: "teal.700" }}
              colorScheme="blue"
              variant="solid"
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
            >
              Donate
            </Button>
          </HStack>
        </Box>
      </Flex>

      <Box as="nav" marginLeft={5} marginRight={5} bg="#D10024" color="white">
        <HStack
          as={"nav"}
          display={{ base: "none", md: "flex" }}
          justifyContent={"space-evenly"}
        >
          <Link
            paddingLeft={5}
            paddingRight={5}
            paddingTop={5}
            paddingBottom={5}
            rounded={"md"}
            _hover={{
              textDecoration: "none",
              color: "lightblue",
            }}
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
            as={ReachLink}
            to={"/"}
          >
            HOME
          </Link>
          <Link
            paddingLeft={5}
            paddingRight={5}
            paddingTop={5}
            paddingBottom={5}
            rounded={"md"}
            _hover={{
              textDecoration: "none",
              color: "lightblue",
            }}
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
            as={ReachLink}
            to={"/government-listing"}
          >
            GOVERNMENT
          </Link>
          <Link
            paddingLeft={5}
            paddingRight={5}
            paddingTop={5}
            paddingBottom={5}
            rounded={"md"}
            _hover={{
              textDecoration: "none",
              color: "lightblue",
            }}
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
            as={ReachLink}
            to={"/political-parties-listing"}
          >
            POLITICAL PARTIES
          </Link>
          <Link
            paddingLeft={5}
            paddingRight={5}
            paddingTop={5}
            paddingBottom={5}
            rounded={"md"}
            _hover={{
              textDecoration: "none",
              color: "lightblue",
            }}
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
            as={ReachLink}
            to={"/politicians-listing"}
          >
            POLITICIANS
          </Link>
          <Link
            paddingLeft={5}
            paddingRight={5}
            paddingTop={5}
            paddingBottom={5}
            rounded={"md"}
            _hover={{
              textDecoration: "none",
              color: "lightblue",
            }}
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
            as={ReachLink}
            to={"/about-us"}
          >
            ABOUT US
          </Link>
        </HStack>

        {isOpen ? (
          <Box
            display={{ md: "none" }}
            textAlign="center"
            paddingTop={5}
            paddingBottom={5}
          >
            <Stack as={"nav"} spacing={4}>
              <Link
                rounded={"md"}
                _hover={{
                  textDecoration: "none",
                  color: "lightblue",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
                as={ReachLink}
                to={"/"}
              >
                HOME
              </Link>
              <Link
                // px={2}
                // py={1}
                rounded={"md"}
                _hover={{
                  textDecoration: "none",
                  color: "lightblue",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
                as={ReachLink}
                to={"/government-listing"}
              >
                GOVERNMENT
              </Link>
              <Link
                // px={2}
                // py={1}
                rounded={"md"}
                _hover={{
                  textDecoration: "none",
                  color: "lightblue",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
                as={ReachLink}
                to={"/political-parties-listing"}
              >
                POLITICAL PARTIES
              </Link>
              <Link
                // px={2}
                // py={1}
                rounded={"md"}
                _hover={{
                  textDecoration: "none",
                  color: "lightblue",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
                as={ReachLink}
                to={"/politicians-listing"}
              >
                POLITICIANS
              </Link>
              <Link
                // px={2}
                // py={1}
                rounded={"md"}
                _hover={{
                  textDecoration: "none",
                  color: "lightblue",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
                as={ReachLink}
                to={"/about-us"}
              >
                ABOUT US
              </Link>
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}

export default Header;
